import React from 'react';
import ExclamacionIcon from "components/Error500/ExclamacionIcon";
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const Error500 = (props) => {
    const {className} = props;

    const goBack = () => {
        if(typeof window !== 'undefined'){
            window.location.reload();
        }
    }

    return( 
        <div className={'error-503-content active ' + (className || '')}>
            <form className="form-container">
                <div className="container-error-modal">
                    <ExclamacionIcon />
                </div>
                <div>
                    <label className="label-message">En estos momentos no podemos completar tu solicitud</label>
                    <label className="label-warning">Por favor, inténtalo más tarde</label>
                </div>
                <div className="actions">
                    <div className="cont-btn">
                        <button type="submit" className='btn btn-sec' onClick={goBack}>
                            <span className={'btn-span-enter'}>Reintentar</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

Error500.propTypes = {
    className: PropTypes.string,
};

export default Error500;
